// extracted by mini-css-extract-plugin
export default {"card":"Statements_card__a2Pt0"};